import { BASE_URL_VCLAIM, instance1, instance2, V1 } from "App/constants"
import { getUserName } from "App/utils/cookies"

export const getKelasRawat = async () => {
  try {
    const api = await instance1.get(`/bridging`, {
      headers: {
        method: "get",
        url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/referensi/kelas-rawat`,
      },
    })

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.list,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getProvinsi = async () => {
  try {
    const api = await instance1.get(`/bridging`, {
      headers: {
        method: "get",
        url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/referensi/propinsi`,
      },
    })

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.list,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response,
    }
  }
}

export const getKabupaten = async (kode) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        kode_propinsi: kode,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/referensi/kabupaten`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.list,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getKecamatan = async (kode) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        kode_kabupaten: kode,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/referensi/kecamatan`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.list,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const getHistoryPelayananPeserta = async (formData) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        no_kartu_peserta: formData.no_bpjs,
        tgl_mulai: formData.tgl_mulai,
        tgl_akhir: formData.tgl_akhir,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/monitoring/data-histori-pelayanan-peserta`,
        },
      },
    )

    const response = api.data.body

    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: response.response.histori,
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const deleteSep = async (nomor_sep) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_sep,
        user: getUserName(),
      },
      {
        headers: {
          method: "DELETE",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/sep/delete`,
        },
      },
    )

    const response = api.data.body

    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: [],
        message: "SEP Berhasil dihapus",
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const updateSep = async (payload) => {
  try {
    const api = await instance1.post(`/bridging`, payload, {
      headers: {
        method: "PUT",
        url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/sep/update`,
      },
    })

    const response = api.data.body

    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: "SEP Berhasil diubah",
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}

export const checkSEP = async (id_registration) => {
  try {
    const api = await instance2.get(`/sep_regist/checkprevsep`, {
      headers: {
        id_registration_ranap: id_registration,
      },
    })

    const response = api.data
    if (parseInt(response.status) === 200) {
      return {
        state: true,
        data: response.body.no_sep,
      }
    } else {
      return {
        state: false,
        data: "",
        message: response.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteSepInternal = async (payload) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        nomor_sep: payload.nomor_sep,
        nomor_surat: payload.nomor_surat,
        tgl_rujukan_internal: payload.tgl_rujukan_internal,
        kode_poli_tujuan: payload.kode_poli_tujuan,
        user: getUserName(),
      },
      {
        headers: {
          method: "DELETE",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/sep/delete-sep-internal`,
        },
      },
    )

    const response = api.data.body

    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: [],
        message: "SEP Internal Berhasil dihapus",
      }
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    }
  }
}
